import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const getVar = function (variable) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
};

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "5vh",
    padding: "3vh",
  },
  unsubscribeButton: {
    color: "error",
    marginRight: "30px",
  },
  cancelButton: {
    color: "success",
  },
}));

function Unsubscribe() {
  const classes = useStyles();
  const [emailAddress, setEmailAddress] = useState("");
  const [subscriptions, setSubscriptions] = useState([]);
  const [jwt, setJwt] = useState(null);
  const history = useHistory();
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);
  const [canClose, setCanClose] = useState(false);

  function unsubscribe() {
    fetch("https://interface.mcsnet.ca/guest/unsubscribeemail", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ut: jwt,
      }),
    }).then((r) => (r.status === 200 ? setDone(true) : setError(true)));
  }

  function cancel() {
    setCanClose(true);
  }

  useEffect(() => {
    const ut = getVar("ut");
    if (!ut) {
      setError(true);
      return;
    }

    const dataString = atob(ut?.split(".")?.[1]);

    if (!dataString) {
      setError(true);
      return;
    }

    const decoded = JSON.parse(dataString);
    if (!decoded.email || !decoded.subscriptions) {
      setError(true);
      return;
    }

    setEmailAddress(decoded.email);
    setSubscriptions(decoded.subscriptions);
    setJwt(ut);

    if (
      history.location.search !== null &&
      history.location.search.length > 0
    ) {
      history.push(history.location.pathname, history.location.state);
    }
  }, []);

  if (error) {
    return (
      <Grid
        container
        className={classes.root}
        direction="column"
        alignContent="center"
        spacing={5}
      >
        <Grid item xs={12} md={8} lg={6}>
          <Typography variant="body1">
            An error occurred. Please try again or contact MCSnet Support at
            1-866-390-3928
          </Typography>
        </Grid>
      </Grid>
    );
  }

  if (done) {
    return (
      <Grid
        container
        className={classes.root}
        direction="column"
        alignContent="center"
        spacing={5}
      >
        <Grid item xs={12} md={8} lg={6}>
          <Typography variant="body1">
            You are now unsubscribed. You can close this tab
          </Typography>
        </Grid>
      </Grid>
    );
  }

  if (canClose) {
    return (
      <Grid
        container
        className={classes.root}
        direction="column"
        alignContent="center"
        spacing={5}
      >
        <Grid item xs={12} md={8} lg={6}>
          <Typography variant="body1">You can close this tab</Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      className={classes.root}
      direction="column"
      alignContent="center"
      spacing={5}
    >
      <Grid item xs={12} md={8} lg={6}>
        <Typography variant="body1">
          We are sorry to see you leaving. <br /> If at any point you want to
          resubscribe again, please contact customer service. <br />
          <br />
        </Typography>
        <Typography variant="body1">
          Are you sure you want to unsubscribe{" "}
        </Typography>
        <Typography color="primary">{emailAddress}</Typography>
        <Typography variant="body1">
          from the following subscriptions?
        </Typography>
      </Grid>
      <Grid item xs={12} md={8} lg={6}>
        {subscriptions.map((sub) => (
          <Typography key={sub} variant="body1">
            ---- {sub[1]}
          </Typography>
        ))}
      </Grid>
      <Grid item xs={12} md={8} lg={6}>
        <Button
          className={classes.unsubscribeButton}
          variant="contained"
          onClick={unsubscribe}
        >
          Yes, unsubscribe
        </Button>
        <Button
          className={classes.cancelButton}
          variant="contained"
          onClick={cancel}
        >
          Cancel
        </Button>
      </Grid>
    </Grid>
  );
}

export default Unsubscribe;
